/**
 * @ngdoc directive
 * @name articlesrows
 *
 * @description
 * Articles row layout
 */
module.directive('articlesrows', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@?',
            limit: '=',
            step: '@',
            labeldisplaymore: '@',
            labelempty: '@',
            labelmore: '@',
            showdate: '@?',
            articles: '=content',
            showMore: '&',
            canLoadMore: '='
        },
        template:
                '<div class="aqua-articlesrows">' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center" ng-if="label"><span class="aqua-articlesrows--title">{{label}}</span></h2>' +

                '    <div class="aqua-articlesrows--items grid grid-v grid-gutter">' +

                '      <article ng-repeat="article in articles | limitTo:limit" content="article" labelmore="{{labelmore}}" showdate="{{showdate}}"></article>' +

                '      <div class="grid grid-center"><button class="aqua-articlesrows--more aqua-form--button aqua-form--button_primary" ng-click="showMore()" ng-show="canLoadMore">{{labeldisplaymore}}</button></div>' +
                '      <div ng-if="articles && articles.length == 0" class="aqua-newspage--empty l-tac">{{labelempty}}</div>' +
                '    </div>' +

                '  </div>' +
                '</div>'
    };
});
